import React from 'react';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

export const DisplayBooleanVertical = props => {
  const { value, label, displayChange } = props;
  const { t } = useTranslation();

  return (
    <Wrapper>
      <div>{t(label)}</div>
      <div>
        {value ? <CheckOutlinedIcon className={`${(displayChange) && 'pendding-color'}`} /> : <CloseOutlinedIcon className={`${(displayChange) && 'pendding-color'}`} />}
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: inherit;
  margin: 0 5px;
  align-items: center;
  
  .pendding-color {
    background-color: ${p => p.theme.pending};
    border-radius: 5px;
  }
`;
